module.exports = __webpack_public_path__ + "img/product-donghuajiaoxue-js-01.4f9f97d6.png";